var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenSchooling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Open_Schooling",
    "data-name": "Open  Schooling",
    transform: "translate(-455 -169)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4265",
    "data-name": "Rectangle 4265",
    width: 93,
    height: 93,
    rx: 10,
    transform: "translate(455 169)",
    fill: "#f0f2ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_01",
    "data-name": 1,
    transform: "translate(479.151 193.794)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9863",
    "data-name": "Path 9863",
    d: "M41.721,3.344a5.267,5.267,0,0,0-4.009-1.391h-.243A38.581,38.581,0,0,0,22.923,6.831l-.312.2a.82.82,0,0,1-.548-.01l-.469-.283a38.442,38.442,0,0,0-14.51-4.8A5.332,5.332,0,0,0,1.25,7.31V31.016a5.522,5.522,0,0,0,4.686,5.344l.575.078A49.513,49.513,0,0,1,20.67,41.093a3.464,3.464,0,0,0,1.67.406,3.336,3.336,0,0,0,1.641-.4A48.864,48.864,0,0,1,38.086,36.44l.652-.079a5.524,5.524,0,0,0,4.71-5.346V7.327a5.346,5.346,0,0,0-1.727-3.984ZM6.906,33.522l-.589-.08a2.573,2.573,0,0,1-2.123-2.426V7.31a2.443,2.443,0,0,1,.773-1.825,2.406,2.406,0,0,1,1.644-.624h.232A35.519,35.519,0,0,1,20.058,9.249l.471.281a3.2,3.2,0,0,0,.345.147V37.9a52.818,52.818,0,0,0-13.968-4.38ZM40.5,31.016a2.569,2.569,0,0,1-2.121,2.424l-.663.08a52.484,52.484,0,0,0-13.9,4.358V9.682a3.183,3.183,0,0,0,.365-.155l.322-.206A35.671,35.671,0,0,1,37.594,4.9h.241A2.4,2.4,0,0,1,40.5,7.327Z",
    transform: "translate(0)",
    fill: "#0012ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9864",
    "data-name": "Path 9864",
    d: "M4.75,9.215A1.472,1.472,0,0,1,6.222,7.743h4.415a1.472,1.472,0,0,1,0,2.944H6.222A1.472,1.472,0,0,1,4.75,9.215Zm7.359,4.415H6.222a1.472,1.472,0,0,0,0,2.944h5.887a1.472,1.472,0,1,0,0-2.944Z",
    transform: "translate(3.369 5.611)",
    fill: "#0012ad"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenSchooling);
export default __webpack_public_path__ + "static/media/OpenSchooling.31b644b5d347c39eb4876755cdcc7a7a.svg";
export { ForwardRef as ReactComponent };